import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { Grid, TextField } from '@mui/material';
import APIService from '../../../../APIService';
import swal from 'sweetalert';

export const RepealedRegulation = () => {

  const [regulations, setRegulations] = useState([])
  const [title, setTitle] = useState("");
  const [fileUpload, setFileUpload] = useState("");
  const [addedOn, setAddedOn] = useState("");

  const [repealedRegulationId, setRepealedRegulationId] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    APIService.get('repealed_regulations')
      .then((response) => {
        setRegulations(response.data);
      });
  }, []);

  const handleFileChange = (e) => {
    if (e.target.files) {
      setFileUpload(e.target.files[0]);
    }
  }

  const changePosition = (direction, itemId) => {

    APIService.post([], `change-position/${direction}/repealed_regulations/${itemId}`)
      .then((response) => {
        // console.log(response);
        if (response.success) {
          APIService.get('repealed_regulations').then((response) => {
            setRegulations(response.data);
          });
        }
      })
  }

  const handleEdit = (itemId, title, addedOn) => {

    setRepealedRegulationId(itemId);
    setIsEditing(true);
    setTitle(title);
    setAddedOn(addedOn);
  }

  const handleDelete = (itemId) => {
    // e.preventDefault();
    swal({
      title: "Are you sure?",
      text: "You want to delete this item?",
      icon: "warning",
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        APIService.delete(`repealed_regulations/${itemId}`).then((response) => {
          swal("Success", response.message, "success", {
            buttons: false,
            timer: 2000,
          }).then((value) => {
            window.location.href = "/repealed_regulations";
          });
        });
      }
    });
  };



  const handleSubmit = async (e) => {

    e.preventDefault();
    const formData = new FormData();

    formData.append("title", title);
    formData.append("file_upload", fileUpload);
    formData.append("added_on", addedOn);

    if (isEditing) {
      var response = await APIService.put(formData, `repealed_regulations/${repealedRegulationId}`);
    } else {
      var response = await APIService.post(formData, "repealed_regulations");
    }

    if (response.success) {
      swal("Success", response.message, "success", {
        buttons: false,
        timer: 2000,
      }).then((value) => {
        window.location.href = "/repealed_regulations";
      });
    } else {
      swal("Failed", response.message, "error");
    }
  }

  return (
    <div>
      <h2 className="organisation-head">Repealed Regulation</h2>

      <form noValidate onSubmit={handleSubmit}>
        <Grid container spacing={3} style={{ marginTop: 10 }}>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Date</p>
            <TextField
              type="date"
              name="date"
              variant="outlined"
              fullWidth
              value={addedOn}
              onChange={e => setAddedOn(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Title</p>
            <TextField
              id="outlined-multiline-static"
              label="Title"
              fullWidth
              value={title}
              onChange={e => setTitle(e.target.value)}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: 10 }}>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Upload File</p>
            <TextField
              name="upload-photo"
              type="file"
              onChange={handleFileChange}
            />
          </Grid>
        </Grid>
        <Button style={{ marginTop: 20 }} variant="primary" type="submit">Submit</Button>{' '}
      </form>

      <Table striped bordered hover variant="light">
        <thead>
          <tr>
            <th>Sl No</th>
            <th>Title</th>
            <th>File</th>
            <th>Date</th>
            <th>Edit</th>
            <th>Delete</th>
            <th>Move Up</th>
            <th>Move Down</th>
          </tr>
        </thead>
        <tbody>
          {regulations.map((regulation, index) => (
            <tr key={regulation.id}>
              <td>{index + 1}</td>
              <td>{regulation.title}</td>
              <td>{regulation.link}</td>
              <td>{regulation.added_on}</td>
              <td><button className='tablebutton'
               onClick={() => handleEdit(regulation.id, regulation.title, regulation.added_on)}
               >Edit</button></td>
              <td><button className='tablebutton'
              onClick={() => handleDelete(regulation.id)}
              >Delete</button></td>
              <td><button className='move-btn'
              onClick={() => changePosition("up", regulation.id)}
              ><img width="32" height="32" src="https://img.icons8.com/external-kmg-design-glyph-kmg-design/32/external-up-arrow-arrows-kmg-design-glyph-kmg-design.png" alt="external-up-arrow-arrows-kmg-design-glyph-kmg-design" /></button></td>
              <td><button className='move-btn'
              onClick={() => changePosition("down", regulation.id)}
              ><img width="36" height="40" src="https://img.icons8.com/fluency-systems-filled/48/thick-arrow-pointing-down.png" alt="thick-arrow-pointing-down" /></button></td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  )
}
